import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Title from "./Title";

export default function CardCountUsers({ count }) {
  const [date, setDate] = useState("");

  const zeroFill = (n) => {
    return ("0" + n).slice(-2);
  };
  useEffect(() => {
    const now = new Date();
    const dataHora =
      zeroFill(now.getUTCDate()) +
      "/" +
      zeroFill(now.getMonth() + 1) +
      "/" +
      now.getFullYear();
    setDate(dataHora);
    return 0;
  }, [date]);

  return (
    <React.Fragment>
      <Title>Usuários cadastrados</Title>
      <Typography component="p" sx={{ flex: 1 }} variant="h4">
        {count > 0 ? count - 1 + " Usuários" : "Não há cadastro"}
      </Typography>
      <Typography color="text.secondary">
        Data de hoje:{"  "}
        {date}
      </Typography>
    </React.Fragment>
  );
}
